import type { TRenderSelectedValuesCtx } from '../../types/filter-config';
import memberApi from '@src/shared/services/member-api';
import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { entityFilterIds } from '../../helpers/filter-none';

const MemberFilterValue = ({ id }: { id: string | number }) => {
  const { data } = memberApi.useFetch({ user: id });
  const member = data?.results?.[0];
  const user = member?.user;

  return (
    <Avatar className='size-6 border-2 border-white'>
      <AvatarImage src={user?.avatar} />
      <AvatarFallback colorId={user?.id as number}>
        {user?.first_name[0]}
      </AvatarFallback>
    </Avatar>
  );
};

export function MemberFilterSelectedValues({
  filter,
}: TRenderSelectedValuesCtx) {
  return (
    <div className='-space-x-2 flex items-center'>
      {entityFilterIds(filter.value).map((val) => {
        return (
          <MemberFilterValue
            key={val}
            id={val}
          />
        );
      })}
    </div>
  );
}
